module.exports = __webpack_public_path__ + "img/skateboarding.86a3b9cb.svg";